import { render, staticRenderFns } from "./servicedRecord.vue?vue&type=template&id=5f648b62&scoped=true"
import script from "./servicedRecord.vue?vue&type=script&lang=ts"
export * from "./servicedRecord.vue?vue&type=script&lang=ts"
import style0 from "./servicedRecord.vue?vue&type=style&index=0&id=5f648b62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f648b62",
  null
  
)

export default component.exports